/**
 * @file: useOpenReservationOrder.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * Open the order a reservation converted into, from its order number. Thin
 * alias over the shared `useOpenOrderDetail` (task when in-progress, service
 * record when finished) — kept for the reservation call sites' readability.
 */

export { useOpenOrderDetail as useOpenReservationOrder } from '@euler/app/flows/common/functions/useOpenOrderDetail';
